import { Phone } from '@phosphor-icons/react'
import Link from 'next/link'
import Button from '@/src/components/core/Button'

export default function PhoneButton({
  number = '0315391065',
}: {
  number?: string
}) {
  return (
    <Button
      as={Link}
      href={`tel:${number}`}
      target="_blank"
      icon={<Phone weight="fill" />}
      rel="noopener noreferrer"
      size="icon-small"
      aria-label="Kontakt Telefon"
    />
  )
}
